import styled from 'styled-components'
import {
  addRow,
  clickDown,
  clickUp,
  widthChange,
} from '../../../../animations/Transitions'
import { cyberColors } from '../../../../lib/colors'

interface elements_style_props {
  active?: boolean
  win?: boolean
  id?: string
}
export const TabDiv = styled.div<elements_style_props>`
  position: relative;
  text-transform: uppercase;
  font-size: 12px;
  cursor: pointer;
  margin-right: 10px;
  opacity: 1;
  transition: all 0.167s;
  color: ${({ active }) =>
    active ? cyberColors.whiteText : cyberColors.greyText};

  &&.active {
    ::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 1px;
      bottom: -1px;
      left: 0;
      background: ${cyberColors.blue};
      ${widthChange}
    }
  }
  :active {
    opacity: 0.5;
    transition: all 0.167s;
    transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
  }
`
export const RowDiv = styled.div``

export const RowData = styled.div<elements_style_props>`
  font-size: 12px;
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ win }) => (win ? cyberColors.lightGreen : cyberColors.whiteDark)};
`
export const RowTitle = styled.div<elements_style_props>`
  text-transform: uppercase;
  font-size: 8px;
  color: ${({ win }) => (win ? cyberColors.green : cyberColors.greyText)};
`
export const RowWrapper = styled.div<elements_style_props>`
  display: flex;
  align-items: center;
  justify-content: center;
  :first-child {
    ${addRow};
  }
  .btn {
    width: 100%;
    display: grid;
    align-items: center;
    cursor: pointer;
    grid-template-columns: 19% 19% 19% 19% 19%;
    grid-column-gap: 4px;
    padding: 4px 10px;
    border-radius: 4px;
    margin-bottom: 5px;
    background: ${({ win }) =>
      win ? cyberColors.darkGreen : cyberColors.greyLight};
    ${clickUp}
    :active {
      ${clickDown}
    }
  }
`
